import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import "./Theme.css";
import "./TermsAndPolicies.css";

const TermsAndPolicies = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;

  return (
    <section className="terms-page">
      <div className="terms-container">
        <div className="terms-card" onClick={() => navigate(`/privacy-policy?${qs}`)}>
          <span className="terms-title">{t("terms.privacyPolicy")}</span>
          <span className="terms-arrow">&#8250;</span>
        </div>
        <div className="terms-card" onClick={() => navigate(`/terms-of-services?${qs}`)}>
          <span className="terms-title">{t("terms.termsOfService")}</span>
          <span className="terms-arrow">&#8250;</span>
        </div>
      </div>
    </section>
  );
};

export default TermsAndPolicies;
